export const zafClient = (window as any).zafClient;

export const getMetaData = async () => {
  const metadata = await zafClient.metadata();
  const metaDataContent = {
    apiToken: metadata.settings.apiToken,
    emailAdmin: metadata.settings.emailAdmin,
  };
  return metaDataContent;
};

export const getCurrentUserId = async (): Promise<number> => {
  const currentUser = await zafClient.get('currentUser');
  return currentUser.currentUser.id;
};

export const getZendeskUrl = (): string => {
  const rawUrl =
    window.location.ancestorOrigins?.[0] ||

    (window as any).initializedClient?._origin ||
    (window as any).zafClient?._origin ||

    document.referrer ||
    window.location.origin ||
    "";

  try {
    const url = new URL(rawUrl);

    return url.hostname.split(".")[0];
  } catch {
    return "";
  }
};


export function popupError(message: string, sticky: boolean) {
  zafClient.invoke("notify", message, "error", { sticky });
}

export function popupText(message: string, sticky: boolean) {
  zafClient.invoke("notify", message, "sucess", { sticky });
}

export const popupWarning = (message: string, sticky: boolean) => {
  zafClient.invoke("notify", message, "alert", { sticky });
};

export async function zendeskRequest<T>(
  url: string,
  method: string,
  data?: string | Record<string, unknown>
): Promise<T> {
  if (!(window as any).zafClient) {
    console.warn("zafClient não encontrado. Executando fora do Zendesk.");
    return Promise.reject("zafClient não inicializado");
  }

  return (await zafClient.request({ url, type: method, data })) as T;
}
